import { getAlertsData } from "../api"
import { toastError, toastWarn } from "../../../errors.toast";
import {
    GET_ALERTS_REQUEST,
    GET_ALERTS_SUCCESS,
    GET_ALERTS_FAILURE,
} from "../const";


const request = () => ({ type: GET_ALERTS_REQUEST});

const success = (alerts) => ({
    type: GET_ALERTS_SUCCESS,
    payload: { alerts },
});
const failure = () => ({ type: GET_ALERTS_FAILURE});

export const receiveAlerts = (params) => async (dispatch) => {
    dispatch(request());
    try {
        const { data: receiveAlertsData } = await getAlertsData(params).catch((error)=> {
            if (error.response.status === 400) {
                toastWarn(`${error.response.status} Bad request`)
            } else {
                if (error.response.status === 500) {
                    toastError(`${error.response.status} Server error`)
                }
            }})

        dispatch(success(receiveAlertsData));
    } catch (e) {
        dispatch(failure());
    };
};